import { render, staticRenderFns } from "./officePriceModal.vue?vue&type=template&id=42a9da63&"
import script from "./officePriceModal.vue?vue&type=script&lang=js&"
export * from "./officePriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports